// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6336":"27b105f2","8424":"27b105f2"}[chunkId] + ".chunk.css";
};